module.exports = __webpack_public_path__ + "img/portfolio-freeteam.8bf844b6.png";